
$(document).on('click','.cart__item-sub button',function(){
  var pro__id = $(this).attr("data-product");
  var pro__qty = $(this).attr("data-qty");
  var button__type = $(this).attr("data-btnType");
  if(button__type=='minus'){
   localStorage.setItem("pro__id", pro__id); 
   localStorage.setItem("pro__qty", parseInt(pro__qty)-parseInt(1)); 
   localStorage.setItem("btntyp", 'minus'); 
  } else if(button__type=='plus'){
    localStorage.setItem("pro__id", pro__id); 
   localStorage.setItem("pro__qty", parseInt(pro__qty)+parseInt(1));
    localStorage.setItem("btntyp", 'plus'); 
  }
});
 

 $(document).on('click','.readmore',function(){
   $('.ctLess').hide();
   $('.cMore').show();
 });
   $(document).on('click','.readless',function(){
   $('.ctLess').show();
   $('.cMore').hide();
 });

$(window).bind("load", function() {
$(".loader-wrp").fadeOut(550);
});


<!-- Klaviyo back in stock start -->  
    var klaviyo = klaviyo || [];
    klaviyo.init({
      account: "VBSTrT",
      platform: "shopify"
    });
    klaviyo.enable("backinstock",{ 
    trigger: {
      product_page_text: "Notify When Available",
      product_page_class: "btn",
      product_page_text_align: "center",
      product_page_margin: "0px",
      replace_anchor: false
    },


    modal: {
     headline: "{product_name}",
     body_content: "Register to receive a notification when this item comes back in stock.",
     email_field_label: "Email",
     button_label: "Notify me when available",
     subscription_success_label: "You're in! We'll let you know when it's back.",
     footer_content: '',
     additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
     drop_background_color: "#000",
     background_color: "#fff",
     text_color: "#222",
     button_text_color: "#fff",
     button_background_color: "#000",
     close_button_color: "#ccc",
     error_background_color: "#fcd6d7",
     error_text_color: "#C72E2F",
     success_background_color: "#d3efcd",
     success_text_color: "#1B9500"
    }
  }); 
// Klaviyo back in stock end 

  $(document).ready(function(){
    
    window.addEventListener("klaviyoForms", function(e) { 
      if (e.detail.type == 'open' || e.detail.type == 'embedOpen') {
        ga('send', 'event', 'Klaviyo form', 'form_open', e.detail.formId);
      }
      if (e.detail.type == 'submit') {
        ga('send', 'event', 'Klaviyo form', 'form_submit', e.detail.formId);
      }
      if (e.detail.type == 'close') {
        ga('send', 'event', 'Klaviyo form', 'form_close', e.detail.formId);
      }
    });

   // product page addon product 
    $('.qwertyword').on('change', function(e){
      var qty_val = $(this).val();
      $(this).parent('.select_box_wrap').attr('data-addon_qtty', qty_val);
    });
    $('.related-products__variant-select').change(function() {
      var variant_id = $(this).find('option:selected').val();
      var variant_img = $(this).find('option:selected').data("variant-img");
      $(this).parent('.select_box_wrap').attr('data-addon_variant_id', variant_id);
      if (variant_img != ''){
        $(this).parent().parent().find('.related-products__image').attr('src', variant_img);
      }
    });
  
  $('.custom_atc_btn').on('click', function(e) {
    var item_qty = $(this).parents('.related_prd_wrap').find('.select_box_wrap').attr('data-addon_qtty');
    var item_variant_id = $(this).parents('.related_prd_wrap').find('.select_box_wrap').attr('data-addon_variant_id');
      if(item_qty > 0) {
        custom_atc(item_variant_id, item_qty, 1);
      }
  });

    //cart drawer code
         $(document).on('click','button.cart-addon__btn',function(){
            var variantID = $("input[type='radio'].cart-addon__variant-id:checked").attr('data-variant_id');
            custom_atc(variantID, 1, 1);
            setTimeout(function() {
              $('.cart__item-details').each(function(){
                 var idd = $(this).attr('prd_id');
                 if(idd == '42883963093156' || idd == '42883963125924' || idd == '42883963158692'){
                    $('.cart-addon__product').hide();
                  }
              });
            }, 1500);   
      });

    //  ajax cart function
    // Add to cart function
  function custom_atc(id, qty, rdc){
    $.ajax({
      type: 'POST',
      async: false,
      url: '/cart/add.js',
      data: {
        quantity: qty,
        id: id
      },
      dataType: 'json',
      success: function(msg) { 
        setTimeout(function(){
          var cart = new theme.CartDrawer
          cart.init()
          cart.open();
        }, 500);
      }
    });
  }    

 setTimeout(function() {
   $('.cart__item-details').each(function(){
     var idd = $(this).attr('prd_id');
     if(idd == '42883963093156' || idd == '42883963125924' || idd == '42883963158692'){
        $('.cart-addon__product').hide();
      }
  });
 }, 3000);
   
   document.addEventListener('cart:updated', function(evt) {
      $('.cart__item-details').each(function(){
         var idd = $(this).attr('prd_id');
           if(idd == '42883963093156' || idd == '42883963125924' || idd == '42883963158692'){
           console.log($(this).closest('.cart__item-sub').find('.js-qty__wrapper'));
            $('.cart-addon__product').hide();
          }
      });
    });
    
    

    // Redirection popup script begains
    /* set and get cookies for newsletter popup */
    $('.redirect--popup-modal .modal__close, #redirect-stay').click(function(){
      	$('.redirect--popup-modal').addClass('hide');
        $('.redirect--popup-modal .modal').fadeOut(100);
    });
    if(getCookie('redirect-popup') != 'true'){
      	$('.redirect--popup-modal').removeClass('hide');
        $('.redirect--popup-modal .modal').delay(8000).fadeIn(200);
    	setCookie('redirect-popup','true','180');
    }
      function setCookie(key, value, expiry) {
          var expires = new Date();
          expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
          document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
      }
      function getCookie(key) {
          var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
          return keyValue ? keyValue[2] : null;
      }
  
  /* set and get cookies for newsletter popup ends &*/

    //Cart drawer gift product checkbox show hide
    $('.cart-addon__product .cart-addon__field').addClass('hide');
    $('.cart-addon__product input[type=checkbox]').click(function(){
      if($(this).is(':checked')) {
        $(this).parents('.cart-addon__product').find('.cart-addon__field').removeClass('hide');
      }
      else {
        $(this).parents('.cart-addon__product').find('.cart-addon__field').addClass('hide');
      }
    });
  });
  

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.disclosure-list__option').forEach(function(option) {
      option.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent default link behavior
  
        var url = this.getAttribute('href'); // Get the href attribute value
        window.location.href = url; // Redirect to the URL
      });
    });
  });


function waitForElement(selector, timeout = 10000) {
    return new Promise((resolve, reject) => {
        const element = document.querySelector(selector);
        if (element) return resolve(element);

        const observer = new MutationObserver(() => {
            const el = document.querySelector(selector);
            if (el) {
                observer.disconnect();
                resolve(el);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        if (timeout) {
            setTimeout(() => {
                observer.disconnect();
                reject(new Error(`Timeout: Element "${selector}" not found within ${timeout}ms.`));
            }, timeout);
        }
    });
}

// Execution guard
let promoInserted = false;

waitForElement('.usf-results .usf-sr-product__image-container')
.then(() => {
    if (promoInserted) return;
    promoInserted = true;

    const productCards = document.querySelectorAll('.usf-results.usf-clear.usf-grid .grid__item.grid-product');
    const promoData = document.querySelector('.promotion-data')?.dataset;

    if (!promoData) return;

    if (productCards.length >= 3 && !promoData.promoImage.includes('no-image') ) {
      const image = `<div data-aos="row-of-null" class="grid__item grid-product small--one-half medium-up--one-quarter aos-init aos-animate">
        <div class="grid-product__content product__banner-image">
          <a href="${promoData.promoLink}" class="promoImage-container">
            <img src="${promoData.promoImage}" width="auto" height="auto" alt/>
            <div class="promoText">${promoData.promoText}</div>
          </a>
        </div>
      </div>`;
      productCards[promoData.promoPosition - 2].insertAdjacentHTML('afterend', image);
    }

    if (productCards.length >= 3 && !promoData.promoImage2.includes('no-image') ) {
      const image = `<div data-aos="row-of-null" class="grid__item grid-product small--one-half medium-up--one-quarter aos-init aos-animate">
        <div class="grid-product__content product__banner-image">
          <a href="${promoData.promoLink2}" class="promoImage-container">
            <img src="${promoData.promoImage2}" width="auto" height="auto" alt/>
            <div class="promoText">${promoData.promoText2}</div>
          </a>
        </div>
      </div>`;
      productCards[promoData.promoPosition2 - 2].insertAdjacentHTML('afterend', image);
    }

    if (productCards.length >= 3 && !promoData.promoLimage.includes('no-image')) {
      const Limage = `<div data-aos="row-of-null" class="product__large-banner-image grid__item grid-product small--one-half medium-up--one-quarter aos-init aos-animate">
        <div class="grid-product__content">
          <a href="${promoData.promoLlink}" class="promoImage-container">
            <img src="${promoData.promoLimage}" alt/>
            <div class="promoText">${promoData.promoLtext}</div>
          </a>
        </div>
      </div>`;
      productCards[promoData.promoLposition - 2]?.insertAdjacentHTML('afterend', Limage);
    }
})

    .catch(err => {
        console.warn(err.message);
    });

    waitForElement('.usf-facets.usf-sr-filters')
    .then(() => {
      const summarySection = document.querySelector(".usf-facets.usf-sr-filters");
      
      const initialOffsetTop = summarySection.offsetTop; // Original position
    
      window.addEventListener("scroll", () => {
        const scrollY = window.scrollY;
    
        if (scrollY >= 252) {
          summarySection.classList.add("sticky");
          summarySection.classList.add("page-width");
        } else {
          summarySection.classList.remove("sticky");
          summarySection.classList.remove("page-width");
        }
      });
    })
    .catch(err => {
        console.warn(err.message);
    });

    waitForElement('.usf-facets__body')
    .then(() => {
      const selectEl = document.querySelector('.usf-sr-config .usf-c-select');
      const targetContainer = document.querySelector('.usf-facets__body');
    
      if (selectEl && targetContainer) {
        targetContainer.appendChild(selectEl);
      }
    })
    .catch(err => {
        console.warn(err.message);
    });




  